var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-wrap"},[_c('section',[_c('div',{staticClass:"error-code"},[_c('h1',[_vm._v("운영기간이 아닙니다.")]),_vm._v(" "),_c('p',[_vm._v("운영 기간을 확인 후 다시 이용해 주시기 바랍니다.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32e2862c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contents/error/Shutdown.vue
// module id = 6yxW
// module chunks = 1